const host = 'https://api.rxchainge.com/api/pm/';
let token = sessionStorage.getItem('token');
if (token == null) {
    token = '';
}
let twoFA = sessionStorage.getItem('twoFA');
if (twoFA == null) {
    twoFA = false;
}
let company_id = sessionStorage.getItem('company_id');
if (company_id == null) {
    company_id = '';
}
let company_logo = sessionStorage.getItem('company_logo');
if (company_logo == null) {
    company_logo = '';
}

const statics = {
    specialities: [
        {
          id: 1,
          name: 'Allergist'
        },
        {
          id: 2,
          name: 'Cardiology'
        },
        {
          id: 3,
          name: 'General Practitioner'
        },
        {
          id: 4,
          name: 'Nurse Practitioner'
        },
        {
            id: 5,
            name: 'Hepatologist'
        }
    ],
    positions: [
        {
          id: 1,
          name: 'Advocate'
        },
        {
          id: 2,
          name: 'Moderator'
        },
        {
          id: 3,
          name: 'Opponent'
        }
    ],
    difficulties: [
        {
          id: 1,
          name: 'Easy'
        },
        {
          id: 2,
          name: 'Medium'
        },
        {
          id: 3,
          name: 'Hard'
        }
    ],
};

export const adminAPI = {
    getSpecialities: function(specialityid=null) {
        if(specialityid != null){
            for(var i = 0; i < statics.specialities.length; i++){
                if(statics.specialities[i].id == specialityid){
                    return statics.specialities[i].name;
                }
            }
        }
        return statics.specialities;
    },
    getPositions: function(positionid=null) {
        if(positionid != null){
            for(var i = 0; i < statics.positions.length; i++){
                if(statics.positions[i].id == positionid){
                    return statics.positions[i].name;
                }
            }
        }
        return statics.positions;
    },
    getDifficulties: function(difficultyid=null) {
        if(difficultyid != null){
            for(var i = 0; i < statics.difficulties.length; i++){
                if(statics.difficulties[i].id == difficultyid){
                    return statics.difficulties[i].name;
                }
            }
        }
        return statics.difficulties;
    },
    getAvatar: function(avatar) {
        return 'https://api.rxchainge.com/img/avatars/' + avatar;
    },
    getCompanies: async() => {
        var companyFound = false;

        if(company_id == ''){
            const response = await fetch(host + 'companies?paginer=0', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();
            console.log(data);

            

            //get subdomain
            var subdomain = window.location.hostname.split('.')[0];
            //lowecase
            subdomain = subdomain.toLowerCase();
            //temporary
            if(subdomain == 'localhost'){
                subdomain = 'novartis';
            }
            for(var i = 0; i < data.data.length; i++){
                if(data.data[i].domain){
                    if(data.data[i].domain.toLowerCase() == subdomain){
                        company_id = data.data[i].uuid;
                        company_logo = data.data[i].logo;
                        sessionStorage.setItem('company_id', company_id);
                        sessionStorage.setItem('company_logo', company_logo);
                        companyFound = true;
                    }
                }
            }
        }
        else{
            companyFound = true;
        }

        return companyFound;
    },
    login: async(username, password) => {
        const response = await fetch(host + 'auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: username, password: password, token_name: 'pm', company_id: company_id}),
        });

        const data = await response.json();
        console.log(data);

        if(data.error){
            return false;
        }

        if(data.data.token != null){
            token = data.data.token;
            sessionStorage.setItem('token', token);
            console.log('Token:', token);
            console.log('Code:', data.data.double_factor_email_code);
            return true;
        }
        else{
            return false;
        }
    },
    twoFA: async(code) => {
        const response = await fetch(host + 'auth/double-factor-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({ 'double_factor_email_code': code}),
        });

        const data = await response.json();
        if(data.data.message != null){
            twoFA = true;
            sessionStorage.setItem('twoFA', twoFA);
            return true;
        }
        else{
            return false;
        }
        console.log(data);
        console.log('Token:', token);
        console.log('Code:', code);
    },
    forgotPassword: async(email) => {
        const response = await fetch(host + 'auth/forgot-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ email: email}),
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    resetPassword: async(email, password, code) => {
        const response = await fetch(host + 'auth/reset-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ email: email, password: password, password_confirmation: password, token: code}),
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    userInfos: async() => {
        const response = await fetch(host + 'auth/user_current', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    updateUserInfos: async(user) => {
        const myHeaders = new Headers();
        myHeaders.append("Accept-Language", "fr");
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + token);
        
        const urlencoded = new URLSearchParams();
        urlencoded.append("name", user.name);
        urlencoded.append("email", user.email);
        urlencoded.append("tel_mobile", user.phone);
        
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow"
        };

        var data = null;
        
        fetch(host + 'auth/update-profil', requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            data = result;
        })
        .catch(error => console.log('error', error));

        return data;
    },
    getNotificationSettings: async() => {
        const response = await fetch(host + 'notifiers', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    updateNotificationSettings: async(notifiers) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('key', 'accept_product_assigned');
        urlencoded.append('value', notifiers.notify);

        const response = await fetch(host + 'notifiers', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    updatePassword: async(password,uuid) => {
        const myHeaders = new Headers();
        myHeaders.append("Accept-Language", "fr");
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + token);

        const urlencoded = new URLSearchParams();
        urlencoded.append("current_password", password.current);
        urlencoded.append("password", password.new);
        urlencoded.append("confirm_password", password.retype);
        urlencoded.append("uuid", uuid);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow"
        };

        var data = null;

        fetch(host + 'auth/update-password', requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            data = result;
        })
        .catch(error => console.log('error', error));

        return data;
    },
    getNotifications: async() => {
        const response = await fetch(host + 'notifier_trackings?code=TranscriptStart', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);

        return data;
    },
    readNotification: async() => {
        const response = await fetch(host + 'notifier_trackings/update-read', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            }
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    dashboard: async() => {
        const response = await fetch(host + 'dashboard', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    getProducts: async() => {
        const response = await fetch(host + 'products?paginer=0', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    getProduct: async(productId) => {
        const response = await fetch(host + 'products/' + productId + '?inclus_relations=doctors', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    addProduct: async(product) => {
        var formData = new FormData();
        formData.append('name', product.name);
        formData.append('description', product.description);

        if(product.logo_file != null){
            formData.append('cover_image', product.logo_file);
        }

        const response = await fetch(host + 'products', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        return data;
    }, 
    updateProduct: async(product) => {
        var formData = new FormData();
        formData.append('_method', 'PUT');
        formData.append('name', product.name);
        formData.append('description', product.description);

        if(product.logo_file != null){
            formData.append('cover_image', product.logo_file);
        }

        //console.log(formData);

        const response = await fetch(host + 'products/' + product.id, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },     
    addToolkit: async(productid,toolkit) => {
        console.log(toolkit);
        console.log(productid);
        var formData = new FormData();
        
        if(toolkit.uploadfile != null){
            formData.append('title', toolkit.name);
            formData.append('document', toolkit.uploadfile);
        }

        const response = await fetch(host + 'products/' + productid + '/televerser', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        return data;
    },
    deleteToolkit: async(toolkitid) => {
        var formData = new FormData();
        formData.append('media_id', toolkitid);
        const response = await fetch(host + 'products/delete-media', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        return data;
    },
    getDoctors: async() => {
        const response = await fetch(host + 'doctors?inclus_relations=objectives&paginer=0', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    addObjection: async(doctorId, description) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('doctor_id', doctorId);
        urlencoded.append('description', description);

        const response = await fetch(host + 'objections', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });
        const data = await response.json();
        console.log(data);
        return data;
    },
    updateObjection: async(doctorId, objection) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('description', objection.text);
        urlencoded.append('doctor_id', doctorId);

        const response = await fetch(host + 'objections/' + objection.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    deleteObjection: async(objectionId) => {
        const response = await fetch(host + 'objections/' + objectionId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    addObjective: async(doctorId, description, order) => {
        var formData = new FormData();
        formData.append('doctor_id', doctorId);
        formData.append('description', description);
        formData.append('order', order);

        const response = await fetch(host + 'objectives', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        return data;
    },
    updateObjective: async(doctorId, objective) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('description', objective.text);
        urlencoded.append('order', objective.order);
        urlencoded.append('doctor_id', doctorId);

        const response = await fetch(host + 'objectives/' + objective.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    deleteObjective: async(objectiveId) => {
        const response = await fetch(host + 'objectives/' + objectiveId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    addDoctor: async(doctor) => {
        console.log(doctor);
        var formData = new FormData();
        formData.append('doctor_name', doctor.name);
        formData.append('doctor_avatar', doctor.avatar);
        formData.append('speciality', doctor.specialty);
        formData.append('position', doctor.position);
        formData.append('difficulty', doctor.difficulty);
        formData.append('description', doctor.description);
        formData.append('product_id', doctor.product);
        formData.append('time', doctor.duration);
        formData.append('mentor', doctor.mentorActive);

        var prompt = "The project involves creating different scaling scenarios involving an AI doctor, Doctor Ross, and a real-life medical screening sales representative. These scenarios will explore the integration of genomic profiling in oncology treatment decisions, specifically the use of OncoExTra, into clinical practice. Experience the future of oncology care through this interactive role-play tool. The task is to create an AI visual role-play that assists medical screening sales representatives (referred to as the user or rep) in promoting, informing about, and demonstrating the capabilities of the innovative Exact Sciences OncoExTra  to Doctor Ross. We have 2 actors in this role play: one actor is you, the AI, henceforth known as Doctor Ross, and the other actor is the user as defined hereafter as the medical screening sales representative, and he is not a doctor. Rules of the Doctor’s Role Play: Doctor Ross is an oncologist focusing in advanced solid tumors that has a strong interest in cutting-edge diagnostic technologies but no knowledge about the specific features and clinical advantages of OncoExTra. He relies on the user (rep) to provide detailed information about this screening system. His curiosity should drive the conversation, focusing on how OncoExTra can provide a more accurate and clinically actionable genomic report, which then can steer treatments in a more effective and efficient direction.  Doctor Ross will start each session by greeting the user and inviting them to introduce the OncoExTra test. Doctor Ross will display an eagerness to understand how the OncoExTra test can be integrated into his clinical practice. He will ask questions about the report and what differentiates the test from other genomic profiling tests to fully grasp the capabilities and benefits of it. \r\n\r\nDoctor Ross will try his best to answer and engage with the medical screening sales representative. Keep in mind, the medical screening sales representative is trying to inform on and sell OncoExTra to Doctor Ross. Every time Doctor Ross has a conversation with the medical screening sales representative, he should imagine the medical screening sales representative as a medical screening representative from Exact Sciences trying to sell him a cancer detection test, but he doesn’t know which test it is for, as he sees many sales reps from many medical screening companies. As such, Doctor Ross should not proactively mention OncoExTra. He should only refer to OncoExTra and its potential uses once the representative has introduced it into the call. \r\n\r\nThe doctor is a reticent conversationalist though he may open more as the conversation progresses. When the conversation starts, it would be realistic for Doctor Ross and the medical device sales representative to exchange a few classic pleasantries before Doctor Ross politely asks the representative to get to the purpose of the visit. Doctor Ross should not begin the conversation by giving an introduction about who he is, as the medical screening sales representative already knows. Mostly, Doctor Ross should be curious to learn how OncoExTra might benefit some of his patients after the medical screening sales representative introduces it. Within the role play, Doctor Ross should not reveal his opinions and potential objections too quickly. Answers to questions should be somewhat abbreviated early in the conversation, although they may lengthen later in the call as established. No more than half of the doctor’s responses should include a question to the medical screening sales representative. To be more realistic, Doctor Ross should not be able to memorize or recite extensive details of any competitive genomic profiling kits and service offerings, although he will be able to paraphrase the most superficial details and high level features of some. He should reformulate any medical technical knowledge as a high-level summary, thereby sounding more like a human. Doctor Ross should answer all questions in a semi-formal professional manner, in approximately 1 to 3 sentences. These should not be run-on sentences to evade the 3-sentence maximum rule. While Doctor Ross is open to a conversation with the medical screening sales representative, in this role play, his primary objective is to learn from the medical screening sales representative, rather than to help the medical screening sales representative. He is a functional practitioner caring for patients with advanced solid tumors. He has a solid understanding of the fundamentals of pathology and DNA and RNA sequencing. He is not well-versed with Exact Sciences products, but he does believe that his hospital’s current process for confirming cancer diagnoses causes unnecessary treatment delays. He believes that an oncology screen that provides treatment and/or clinical trial recommendations based on genomic mutations must exist for his patients. He has a diverse patient population, with cancerous tumors on various parts of the body, including colorectal, lung, and breast.  Accuracy remains his primary concern when it comes to oncology screens, although he does have additional interest in a test that comes with support, including educational materials as well as support for report analysis, financial assistance, and so forth.  Oncologists are notoriously busy, and Doctor Ross is no exception. Doctor Ross should be a little coy, and not be so anxious to move the conversation along. The doctor doesn’t ask too many questions. It is quite common for doctors in these scenarios to simply answer the question, often only partially, and then simply await the next contribution to the conversation from the rep. Remember doctors are often coy and it often takes many questions for the rep to draw information and openly share information with the rep. Ross, while perhaps initially skeptical of any differentiating factors OncoExTra may have compared to competitors, he is a classic early adopter of new technologies and he will be open to a trial, if the rep can convince him. He will need to see compelling evidence from the analytic validation and clinical trial results. Regarding the potential unique value of OncoExTra, he would also be interested to know if the outspoken oncologist Doctor Bracca has given their assessment. The doctor expects the sales representative to be respectful throughout the conversation. If not, the doctor will cut the conversation short and will not continue unless the rep apologizes. \r\n\r\n \r\n\r\nDoctor Ross is a renowned oncologist with over 20 years of experience. His practice focuses on diagnosing and managing advanced solid tumors using the latest therapeutic and diagnostic technologies. He's particularly interested in exploring how innovative screenings like OncoExTra can improve patient outcomes and procedural efficiencies. Doctor Ross actively participates in various clinical trials and advocates for incorporating new screening methods into his practice. \r\n\r\nHere's a deeper look into Doctor Prometheus' background: \r\n\r\nFull Name: Doctor Ross \r\n\r\nAge: 54 years \r\n\r\nLocation: Cleveland, Ohio \r\n\r\nSpecialty: Oncologist  \r\n\r\nPractice Location: Cleveland Clinic \r\n\r\nEducation:  \r\n\r\nUndergraduate: Bachelor of Science in Biology, The Ohio State University \r\n\r\nMedical School: Doctor of Medicine (MD), Harvard Medical School \r\n\r\nResidency: Oncology, Mayo Clinic \r\n\r\nProfessional Associations: American Society of Clinical Oncology, American Association for Cancer Research \r\n\r\nHobbies and Interests: Keen interest in genomic profiling, avid reader of medical  journals about immunotherapy, enjoys kayaking and photography \r\n\r\nFamily: Married with two unmarried children in their 20s \r\n\r\nDuring the role-play, Doctor Ross' objectives are to: \r\n\r\nUnderstand the operational advancements of OncoExTra. \r\n\r\nExplore potential benefits of specific functions like whole transcriptome sequencing (WTS) for improved clinical outcomes in his patients. \r\n\r\nChallenge the representative to present evidence and real-world data supporting the integration of OncoExTra into his practice.";
        //replace ross with doctor name
        prompt = prompt.replace(/Ross/g, doctor.name);

        formData.append('prompt', doctor.description);
        
        const response = await fetch(host + 'doctors', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        var uuid = data.data.uuid;

        if(doctor.objections != null && doctor.objections.length > 0){
            for(var i = 0; i < doctor.objections.length; i++){
                await adminAPI.addObjection(uuid, doctor.objections[i]);
            }
        }

        if(doctor.objectives != null && doctor.objectives.length > 0){
            for(var i = 0; i < doctor.objectives.length; i++){
                await adminAPI.addObjective(uuid, doctor.objectives[i], i+1);
            }
        }

        return data;
    },
    getDoctor: async(doctorId) => {
        const response = await fetch(host + 'doctors/' + doctorId + '?inclus_relations=product,objections,objectives,reps', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    updateDoctor: async(doctor) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('doctor_name', doctor.name);
        urlencoded.append('doctor_avatar', doctor.avatar.id);
        urlencoded.append('speciality', doctor.speciality.id);
        urlencoded.append('position', doctor.position.id);
        urlencoded.append('difficulty', doctor.difficulty.id);
        urlencoded.append('description', doctor.description);
        urlencoded.append('product_id', doctor.product.id);
        urlencoded.append('prompt', doctor.prompt);
        urlencoded.append('time', doctor.duration);
        urlencoded.append('mentor', doctor.mentorActive);


        const response = await fetch(host + 'doctors/' + doctor.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    getReps: async() => {
        const response = await fetch(host + 'reps?paginer=0', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    attachReps: async(doctorId, repsAttach) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('doctor_id', doctorId);

        for(var i = 0; i < repsAttach.length; i++){
            urlencoded.append('rep_id[]', repsAttach[i]);
        }

        const response = await fetch(host + 'doctors/attach-reps', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    detachReps: async(doctorId, repsDetach) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('doctor_id', doctorId);

        for(var i = 0; i < repsDetach.length; i++){
            urlencoded.append('rep_id[]', repsDetach[i]);
        }

        const response = await fetch(host + 'doctors/detach-reps', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    getRep: async(repId) => {
        const response = await fetch(host + 'reps/' + repId + '?inclus_relations=doctors', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });

        const data = await response.json();
        console.log(data);

        return data;
    },
    addRep: async(rep) => {
       var formData = new FormData();
        formData.append('name', rep.name);
        formData.append('email', rep.email);
        formData.append('password', rep.password);
        formData.append('phone', rep.phone);
        formData.append('location', rep.location);
        formData.append('skill_level', rep.skillLevel);
        formData.append('year_with_company', rep.YearsWithCompany);
        formData.append('prefered_language', rep.language);
        
        const response = await fetch(host + 'reps', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: formData,
        });
        const data = await response.json();
        console.log(data);
        return data;
    },
    updateRep: async(rep) => {
        var urlencoded = new URLSearchParams();
        urlencoded.append('name', rep.name);
        urlencoded.append('email', rep.email);
        urlencoded.append('phone', rep.phone);
        urlencoded.append('location', rep.location);
        urlencoded.append('skill_level', rep.skillLevel);
        urlencoded.append('year_with_company', rep.YearsWithCompany);
        urlencoded.append('prefered_language', rep.language);

        const response = await fetch(host + 'reps/' + rep.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
            },
            body: urlencoded,
        });

        const data = await response.json();
        console.log(data);
        return data;
    },
    getTranscripts: async(repId, doctorId) => {
        const response = await fetch(host + 'transcripts?paginer=0&inclus_relations=doctor,objectives&rep_id=' + repId + '&doctor_id=' + doctorId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        });
        const data = await response.json();
        console.log(data);

        return data;
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js